import React from 'react'
import subscribeImg1 from '../../assets/images/easylife365/haengematte600px.png'
import shape6 from '../../assets/images/shape/vector-shape6.png'
import BookDemoButton from './BookDemoButton'
import { useTranslation } from '../../plugins/i18next/ea-react-i18next';

const Bookdemo = () => {
    const { t } = useTranslation("components", { keyPrefix: 'start.bookdemo' });

    return (
        <div id="bookDemo" className="subscribe-area ptb-70">
            <div className="container-fluid hero-container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="subscribe-image">
                            <img src={subscribeImg1} alt="subscribe" />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12">
                        <div className="subscribe-content">
                            <h2>{t('title')}</h2>
                            <p>{t('description')}</p>

                            <BookDemoButton />
                        </div>
                    </div>
                </div>
            </div>

            <div className="vector-shape6">
                <img src={shape6} alt="shape" />
            </div>
        </div>
    )
}

export default Bookdemo;
